import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`font-mono text-xs font-medium uppercase tracking-[0.25em] ${
      light ? "text-gold" : "text-terracotta"
    }`}
  >
    {children}
  </span>
);

export const SectionHeader = ({ eyebrow, title, sub, light = false, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <Eyebrow light={light}>{eyebrow}</Eyebrow>
    <h2
      className={`mt-4 font-serif text-2xl font-normal tracking-tight sm:text-3xl lg:text-4xl ${
        light ? "text-sand" : "text-azur"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p
        className={`mt-4 max-w-2xl text-base font-light leading-relaxed sm:text-lg ${
          light ? "text-sand/70" : "text-slate-600"
        } ${align === "center" ? "mx-auto" : ""}`}
      >
        {sub}
      </p>
    )}
  </Reveal>
);
